import { ContentType } from '../../shared/types'
import { FileType } from '../misc'

export const GIF_TYPE = 'gifs'
export const PHOTO_TYPE = 'photos'
export const ARTICLE_TYPE = 'articles'
export const VIDEO_TYPE = 'videos'
export const STATUS_TYPE = 'status'
export const TEXT_TYPE = 'texts'

export const POST_TYPES: ContentType[] = [PHOTO_TYPE, ARTICLE_TYPE, VIDEO_TYPE, STATUS_TYPE]

export const ALL_FILTER = 'all'

export const CONTENT_TYPE_TO_FILE_TYPE: { [key: string]: FileType } = {
  [PHOTO_TYPE]: FileType.Image,
  [GIF_TYPE]: FileType.Gif,
  [VIDEO_TYPE]: FileType.Video
}

// export const CONTENT_TYPE_STOCK_MAP: Record<string, ContentType> = {
//   [STOCK_PHOTO_TYPE]: PHOTO_TYPE,
//   [STOCK_VIDEO_TYPE]: VIDEO_TYPE,
//   [STOCK_GIF_TYPE]: GIF_TYPE,
//   [ARTICLE_TYPE]: ARTICLE_TYPE,
//   [VIDEO_TYPE]: VIDEO_TYPE
// }
